import { yellow } from "@mui/material/colors";

const Colors = {
  backgroundColor: "#fefefe",
  //dashboardBgColor: "#e0e8e9",
  // dashboardBgColor: "#ECF9F8",
  dashboardBgColor: "#fbfbfb",
  darkblue: "#122d54",

  primary: "#bf9668 ",
  // primary: "#5ac4bd ",
  yellow: "rgba(252, 190, 45, 1)",
  seaGreen: "rgba(0, 182, 155, 1)",
  red: "rgba(253, 84, 84, 1)",


  secondary: "#0BD1D1",
  white: "#FFFFFF",
  black: "#000000",
  textColor1: "#B9E0F2",
  textColor2: "#7F92B0",
  grey: "#A0AEC0",
};

export default Colors;
